export const measurementUnits = [
  'мл',
  'л',
  'мкг',
  'мг',
  'г',
  'мкг/мл',
  'мг/мл',
  'г/мл',
  'МЕ/мл.',
]